import { render, staticRenderFns } from "./EmployeeMergeReview.vue?vue&type=template&id=35ea23b0&scoped=true&"
import script from "./EmployeeMergeReview.vue?vue&type=script&lang=js&"
export * from "./EmployeeMergeReview.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeMergeReview.vue?vue&type=style&index=0&id=35ea23b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ea23b0",
  null
  
)

export default component.exports